import { Box, Button, Chip, Paper, Stack, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import LocationPinIcon from "@mui/icons-material/LocationOn";
import { TagChip } from "../../../components/TagChip";
import BusinessIcon from "@mui/icons-material/Business";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

export enum EventType {
  ON_DEMAND = "On Demand",
  LIVE = "Live",
}
const eventIcons = {
  [EventType.ON_DEMAND]: <PlayCircleOutlineIcon fontSize="small" />,
  [EventType.LIVE]: <BusinessIcon fontSize="small" />,
};

export const EventCard = ({
  eventLink,
  eventImage,
  eventTitle,
  eventDate,
  eventLocation,
  eventTag,
  eventType,
}: {
  eventLink: string;
  eventImage: string;
  eventTitle: string;
  eventDate: string;
  eventLocation: string;
  eventTag: string;
  eventType: EventType;
}) => {
  return (
    <Box className="event-card" sx={{ height: "100%" }}>
      <Paper
        elevation={0}
        sx={{
          overflow: "hidden",
          borderRadius: 3, // 12px
          height: "100%",
          backgroundColor: "#fff",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.06)", // Subtle, soft shadow
        }}
      >
        <Box className="image-container" sx={{ position: "relative" }}>
          <Chip
            icon={eventIcons[eventType]}
            label={eventType}
            color={"purple" as any}
            sx={{
              position: "absolute",
              top: 16,
              left: 16,
              background: "#6366F1",
              color: "#fff",
              py: 0.5, // 8px
              px: 0.5, // 8px
              minWidth: 'auto',
              width: 'fit-content',
              borderRadius: 50,
            }}
          />

          <Typography
            variant="body2"
            fontWeight={600}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              marginRight: "-50%",
              maxWidth: "90%",
            }}
          >
            {eventTitle}
          </Typography>
          <img
            src={eventImage}
            alt={eventTitle}
            className="event-image"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
            }}
          />
        </Box>
        <Box className="event-content" sx={{ p: 2 }}>
          <Stack
            spacing={2.5}
            sx={{ minHeight: "170px" }}
            justifyContent={"space-between"}
          >
            <Stack spacing={2.5}>
              <Stack
                direction="row"
                justifyContent={"space-between"}
                alignItems="center"
              >
                <TagChip
                  sx={{
                    fontSize: "14px",
                    p: 1,
                    py: 0.5,
                  }}
                >
                  {eventTag}
                </TagChip>
                <Typography
                  variant="body1"
                  className="font-body"
                  color="text.secondary"
                >
                  {eventDate}
                </Typography>
              </Stack>

              <Typography
                variant="body2"
                className="font-body"
                fontWeight={600}
              >
                {eventTitle}
              </Typography>
            </Stack>

            <Stack
              direction="row"
              justifyContent={"space-between"}
              alignItems="center"
            >
              <Stack direction="row" spacing={2} alignItems={"center"}>
                <LocationPinIcon color={"purple" as any} />
                <Typography variant="body1" color="text.secondary">
                  {eventLocation}
                </Typography>
              </Stack>
              <Button
                size="large"
                color={"purple" as any}
                href={eventLink}
                endIcon={<EastIcon />}
              >
                <Typography variant="body1">RSVP</Typography>
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};
